import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useGetExercises } from 'redux/customHooks/useGetExercises'
import { setAssessment } from 'redux/slices/generator'
import { Switch } from '@headlessui/react'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

import AssessmentInputLinearDial from '../AssessmentInputLinearDial'
// import AssessmentInputEDSToggle from '../AssessmentInputEDSToggle'

import runAssessment from 'json/runAssessmentTemplate.json'
import triathlonAssessment from 'json/triAssessmentMaleTemplate.json'
import cyclingAssessment from 'json/cycleAssessmentTemplate.json'
import swimAssessment from 'json/swimAssessmentMaleTemplate.json'

export default function AssessmentInputContainer() {

    const dispatch = useDispatch()
    const { exercises } = useGetExercises()

    const sportInput = useSelector((state) => state.generator.inputs.sport)
    const assessmentInput = useSelector(state => state.generator.inputs.assessment)

    const [detailsExpanded, setDetailsExpanded] = useState(false)
    
    const OnActivateAssessmentToggle = () => {
        if (assessmentInput !== null) dispatch(setAssessment(null))
        if (assessmentInput === null) OnActivateAssessment()
    }

    const OnActivateAssessment = () => {

        var assessmentTemplate = null

        if (sportInput === 'triathlon') assessmentTemplate = triathlonAssessment
        else if (sportInput === 'cycling') assessmentTemplate = cyclingAssessment
        else if (sportInput === 'swimming') assessmentTemplate = swimAssessment
        else assessmentTemplate = runAssessment

        var newAssessment = JSON.parse(JSON.stringify(assessmentTemplate))

        // For each phase
        newAssessment.phases.map((phase) => {

            // Add a completed boolean
            phase.completed = false

            // For each exercise
            phase.exercises.map((exercise) => {

                // Cache the exercise video URL
                exercise.videoUrl = exercises.find((item) => item.id === exercise.id).videoUrl

                // For each set
                exercise.sets.map((set) => {

                    // Add default values for recommendation data
                    set.recommendationData = {
                        weightRecommendationLoaded: false,
                        weightRecommendation: 0,
                        weightRecommendationRounded: 0,
                        formulaTag: '',
                        equipmentDetails: null,
                    }

                    // Default obejct to bilateral object
                    var newCompletedSetData = {
                        savingResult: false,
                        completed: false,
                        setUnitsCompleted: set.reps,
                        movementDifficulty: 0,
                        difficulty: 0,
                        override: 0,
                        databaseId: 0,
                    }

                    // If the exercise is unilateral, set the set units completed to the left and right sides
                    if (exercise.lateral === 'unilateral') {

                        newCompletedSetData.setUnitsCompleted = {
                            leftSide: set.reps,
                            rightSide: set.reps,
                        }

                    }

                    set.completedSetData = newCompletedSetData

                })
            })
        })

        dispatch(setAssessment(newAssessment))
        
    }

    const CalculateSetPercentageScore = (lateral, set) => {

        let user_score = 0
        let max_score = 1

        try {

            if (lateral === 'bilateral') {
                user_score = set.completedSetData.setUnitsCompleted;
                max_score = set.reps;
            }

            if (lateral === 'unilateral') {
                user_score = set.completedSetData.setUnitsCompleted.leftSide + set.completedSetData.setUnitsCompleted.rightSide;
                max_score = set.reps * 2;
            }

        } catch (error) {
            console.error('Error processing assessment workout template', error)
        }
        
        // Aggregate total reps completed
        // totalReps += max_score
        // if (set.completedSetData.completed) totalRepsCompleted += user_score

        // var userScore = exerciseSet.completedSetData.setUnitsCompleted
        // var maxScore = exerciseSet.reps

        return (user_score / max_score) * 100

    }

    useEffect(() => {

        if (assessmentInput === null) return

        OnActivateAssessment()

    }, [sportInput])

    return (
        <div className='bg-white border border-gray-400 p-4 rounded-xl space-y-6'>

            {/* Expand Details Toggle */}
            <div 
                className='flex items-center cursor-pointer gap-x-4'
                onClick={() => setDetailsExpanded(!detailsExpanded)}
            >
                <div className='flex-grow'>Assessment</div>
                {assessmentInput === null && <div className='text-sm font-bold text-red-400'>OFF</div>}
                {assessmentInput !== null && <div className='text-sm font-bold text-green-400'>ON</div>}
                {!detailsExpanded && <ChevronDownIcon className='w-6 h-6 text-gray-400' />}
                {detailsExpanded && <ChevronUpIcon className='w-6 h-6 text-gray-400' />}
            </div>

            {detailsExpanded && 

                <div className='p-4 bg-gray-50 space-y-4 rounded-lg overflow-hidden'>

                    <div 
                        className='flex items-center gap-x-4 cursor-pointer'
                        onClick={() => OnActivateAssessmentToggle()}
                    >

                        <div className='flex-grow'>Activate Assessment Input</div>

                        <Switch
                            checked={assessmentInput !== null}
                            className={`
                                relative inline-flex h-4 w-8 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2
                                ${assessmentInput !== null ? 'bg-orange-600' : 'bg-gray-200'}
                            `}
                        >
                            <span className="sr-only">Use setting</span>
                            <span
                                aria-hidden="true"
                                className={`
                                    pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out
                                    ${assessmentInput !== null ? 'translate-x-4' : 'translate-x-0'}
                                `}
                            />
                        </Switch>

                    </div>

                    {assessmentInput !== null && assessmentInput.phases.map((phase, phaseIndex) => (
                        <div 
                            key={phaseIndex}
                            className='space-y-4'
                        >

                            {phase.exercises.map((exercise, exerciseIndex) => (
                                <div 
                                    key={exerciseIndex}
                                    className='flex items-center'
                                >

                                    <div className='flex-grow'>
                                        <div>{exercise.name}</div>
                                        {exercises.length > 0 && 
                                            <div className='text-xs text-gray-600'>{exercises.find((item) => item.id === exercise.id).category}</div>
                                        }
                                    </div>

                                    {exercise.lateral === 'unilateral' &&
                                        <div className='w-1/2 flex items-center gap-x-2'>
                                            <div className='flex-grow'>
                                                <AssessmentInputLinearDial 
                                                    lateralKey='unilateral-left'
                                                    phaseIndex={phaseIndex}
                                                    exerciseIndex={exerciseIndex}
                                                />
                                            </div>
                                            <div className='flex-grow'>
                                                <AssessmentInputLinearDial 
                                                    lateralKey='unilateral-right'
                                                    phaseIndex={phaseIndex}
                                                    exerciseIndex={exerciseIndex}
                                                />
                                            </div>
                                        </div>
                                    }
                                    
                                    {exercise.lateral === 'bilateral' && 
                                        <div className='w-1/2'>
                                            <AssessmentInputLinearDial 
                                                lateralKey='bilateral'
                                                phaseIndex={phaseIndex}
                                                exerciseIndex={exerciseIndex}
                                            />
                                        </div>
                                    }

                                    {/* <AssessmentInputEDSToggle
                                        phaseIndex={phaseIndex}
                                        exerciseIndex={exerciseIndex}
                                    /> */}

                                    <div 
                                        className={`
                                            w-32 text-center font-semibold
                                            ${CalculateSetPercentageScore(exercise.lateral, exercise.sets[0]) < 75 ? 'text-red-500' : 'text-green-500'}
                                        `}
                                    >
                                        Score: {CalculateSetPercentageScore(exercise.lateral, exercise.sets[0]).toFixed(2)}%
                                    </div>

                                </div>
                            ))}

                        </div>
                    ))}

                </div>

            }

        </div>
    )

}